module.exports = "/_next/static/images/copy-718f3fae20f533b0cfe440ce712db8f9.svg";